import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PhoneMock } from "./PhoneMock";
import { LoyaltyCard } from "./LoyaltyCard";

const sectors = [
  "Boulangeries",
  "Coiffeurs",
  "Salles de sport",
  "Instituts beauté",
  "Restaurants",
  "Cafés",
  "Supermarchés",
  "Boutiques",
];

export function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-cream pb-10 pt-8">
      <div className="pointer-events-none absolute -left-32 top-0 h-[440px] w-[440px] rounded-full bg-coral/[0.06] blur-3xl" />
      <div className="pointer-events-none absolute -right-32 top-40 h-[440px] w-[440px] rounded-full bg-orange/[0.06] blur-3xl" />

      <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 lg:grid-cols-2 lg:px-8">
        <div>
          <motion.h1
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.05 }}
            className="text-5xl font-extrabold leading-[1.05] tracking-tight text-ink lg:text-6xl"
          >
            Transformez chaque
            <br />
            passage en{" "}
            <span className="text-gradient">client fidèle</span>.
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="mt-6 max-w-lg text-lg text-ink-soft"
          >
            Carte de fidélité dans leur téléphone en quelques secondes — sans appli. Un
            tampon en un clic depuis votre caisse ou votre téléphone à chaque passage.
            Vous récupérez leurs coordonnées dès la création de la carte.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="mt-8 flex flex-wrap items-center gap-4"
          >
            <a
              href="#demo"
              className="inline-flex items-center gap-2 rounded-full bg-ink px-7 py-3.5 text-sm font-semibold text-white shadow-soft transition-transform hover:scale-[1.03]"
            >
              Réserver une démo <ArrowRight size={16} />
            </a>
            <a
              href="#comment-ca-marche"
              className="inline-flex items-center gap-2 rounded-full border border-line bg-white px-7 py-3.5 text-sm font-semibold text-ink transition-colors hover:border-ink"
            >
              Découvrir comment ça marche
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="mt-10 flex flex-wrap gap-2"
          >
            {sectors.map((sector) => (
              <span
                key={sector}
                className="rounded-full border border-line bg-white px-3.5 py-1.5 text-xs font-medium text-ink-soft"
              >
                {sector}
              </span>
            ))}
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.92, rotate: -2 }}
          animate={{ opacity: 1, scale: 1, rotate: 0 }}
          transition={{ duration: 0.7, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
        >
          <PhoneMock>
            <div className="flex items-center justify-between px-1 pb-4 pt-2">
              <p className="text-sm font-bold text-ink">Wallet</p>
              <span className="rounded-full bg-mint/15 px-2 py-0.5 text-[10px] font-semibold text-mint-text">
                Ajoutée ✓
              </span>
            </div>
            <LoyaltyCard />
            <div className="mt-4 rounded-xl border border-line bg-white p-3">
              <p className="text-xs font-semibold text-ink">Tampon ajouté !</p>
              <p className="mt-0.5 text-[11px] text-ink-soft">
                Mise à jour instantanée dans le wallet — plus que 3 pour le café offert.
              </p>
            </div>
          </PhoneMock>
        </motion.div>
      </div>
    </section>
  );
}
